import {Component, computed} from '@angular/core';
import {ManageTaBaseComponent} from '../manage-ta-base-component.directive';
import {Button} from 'primeng/button';
import {DatePipe} from '@angular/common';
import {TaCostBubbleComponent} from '../../ta-cost-bubble/ta-cost-bubble.component';
import {ManageTaDayTripPaymentTable} from '../manage-ta-day-trip-payment-table/manage-ta-day-trip-payment-table';
import {TaApprovalsTableComponent} from '../ta-approvals-table/ta-approvals-table.component';
import {TRAVEL_APPROVAL_CONTEXTS} from '../../../../util/approval-workflow.utils';

@Component({
  selector: 'manage-ta-travel-approved',
  imports: [
    Button,
    DatePipe,
    TaCostBubbleComponent,
    ManageTaDayTripPaymentTable,
    TaApprovalsTableComponent,
  ],
  templateUrl: './manage-ta-travel-approved.component.html',
  styleUrl: './manage-ta-travel-approved.component.scss',
})
export class ManageTaTravelApprovedComponent extends ManageTaBaseComponent {
  readonly travelContexts = TRAVEL_APPROVAL_CONTEXTS;
  canProcessPrepayment = computed(() => this.permissionService.canProcessPrepayment());
  isPrepaymentProcessed = computed(() => {
    return (this.taSubmission()?.approvals?.filter((approval) => (approval.actionContext === "PrePayment" && approval.status === "Actioned" && approval.actionType !== "Cancelled")) ?? []).length > 0
  });

  // dayTripPaymentRows reads the full itinerary list.
  override ngOnInit() {
    super.ngOnInit();
    this.taSubmissionDatasource.getAllItineraries();
  }

  confirmProcessPrepayment(): void {
    this.confirmationServiceWrapper.processPrepaymentConfirm().subscribe({
      next: () => {},
      error: err => {
        console.error(err);
      },
    });
  }
}
